import React from 'react';
import CountUp from 'react-countup';
import './state-counter.css';
import './../style/common.css'

const stats = [
  { number: 240, label: 'ORDERS PER DAY' },
  { number: 180, label: 'GREAT MOMENTS' },
  { number: 100, label: 'HAPPY CUSTOMERS' },
  // { number: 23, label: 'YEARS OF OPERATION' }
];

const StatsCounter = () => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        {stats.map((item, index) => (
          <div className="stat-item" key={index}>
            <CountUp end={item.number} duration={3} delay={0.5} />
            <span className="stat-label">{item.label}</span>
            {index !== stats.length - 1 && <div className="divider" />}
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsCounter;
